import { NgModule, ModuleWithProviders } from '@angular/core';
import { TempDataService } from './temp-data/temp-data.service';
import { EnergyDataService } from './energy-data/energy-data.service';
import { DataAnalyticsConfigService } from './data-analytics-config.service';
import { DataAnalyticsService } from './data-analytics/data-analytics.service';
import { HttpService } from './services/http.service';
import { DataAnalyticsConfig } from './interfaces/all';
import { PopupComponent } from './common-components/popup/popup.component';
@NgModule()
export class DataAnalyticsModule {
    static forRoot(config: DataAnalyticsConfig): ModuleWithProviders<DataAnalyticsModule> {
        return {
            ngModule: DataAnalyticsModule,
            providers: [
                TempDataService,
                EnergyDataService,
                DataAnalyticsService,
                HttpService,
                {
                    provide: DataAnalyticsConfigService,
                    useValue: {url: 'https://publicapi.lightwaverf.com/v3/data/pass',
                    demoUrl: 'https://publicapi.lightwaverf.com/demo/data/pass/',
                    apiKey: 'use access token'}
                }
            ]
        };
    }
}
